/*import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

createApp(App).use(store).use(router).mount('#app')*/
if (window.location.href.includes('%23')) {
    // Ersetze %23 durch #
    const newUrl = window.location.href.replace('%23', '#');

    // Leite zur neuen URL weiter
    window.location.replace(newUrl);
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initializeApp } from 'firebase/app'
import store from "./store";
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import Vue3TouchEvents from "vue3-touch-events";

loadFonts();
// Initialize Firebase
const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID
}

initializeApp(firebaseConfig)

const app = createApp(App);
app.use(router);
app.use(store);
app.use(vuetify);
app.use(Vue3TouchEvents);
app.mount('#app');
